import { render, staticRenderFns } from "./ReturnOrderEdit.vue?vue&type=template&id=5627c530&scoped=true"
import script from "./ReturnOrderEdit.vue?vue&type=script&lang=js"
export * from "./ReturnOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5627c530",
  null
  
)

export default component.exports